import axios from 'axios';
import { IsHtml } from '../shared/Functions';
import DOMPurify from 'dompurify';

export async function HandleAddActivity(activity, setIsSaving) {
    const url = 'api/crmActivityFront/addActivity/';
    if (IsHtml(activity.notes)) {
        activity.notes = DOMPurify.sanitize(activity.notes);
    }
    const res = await axios.post(url, activity).then(
        (response) => {
            setIsSaving && setIsSaving(false);
            if (response.status === 200) {
                return { success: true, error: null, data: response.data };
            } else {
                return { success: false, error: response.data.message, data: null };
            }
        },
        (error) => {
            setIsSaving && setIsSaving(false);
            return { success: false, error: 'Det gick inte att spara ändringen, vänligen kontakta alltid@consid.se.', data: null };
        }
    );

    return res;
}

export async function HandleRemoveActivity(activity, setIsSaving) {
    const url = 'api/crmActivityFront/removeActivity/';

    const query = {activityId:activity.id};

    const res = await axios.delete(url, {params : query}).then(
        (response) => {
            setIsSaving && setIsSaving(false);
            if (response.status === 200) {
                return { success: true, error: null, data: response.data };
            } else {
                return { success: false, error: response.data.message, data: null };
            }
        },
        (error) => {
            setIsSaving && setIsSaving(false);
            return { success: false, error: 'Det gick inte att spara ändringen, vänligen kontakta alltid@consid.se.', data: null };
        }
    );

    return res;
}
